module.exports = __webpack_public_path__ + "static/media/Logout.988d0e44.svg";